import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { combiner, featureKey } from './combiner';

import { LoginEffects } from './login/effects';
import { LoginService } from './login/service';
import { VertiLoginEffects } from './vertiLogin/effects';
import { VertiLoginService } from './vertiLogin/service';
import { RefreshLoginEffects } from './refreshLogin/effects';
import { RefreshLoginService } from './refreshLogin/service';

@NgModule({
  imports: [
    EffectsModule.forFeature([LoginEffects, VertiLoginEffects, RefreshLoginEffects]),
    StoreModule.forFeature(featureKey, combiner),
  ],
  providers: [LoginService, VertiLoginService, RefreshLoginService],
})
export class AuthenticationsStoreModule {}
